import { render } from "./BestServices.vue?vue&type=template&id=af9b7868"
import script from "./BestServices.vue?vue&type=script&lang=js"
export * from "./BestServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__